module.exports = __webpack_public_path__ + "img/invalid-right.04ed06f8.svg";